import { Box, Button, Typography } from "@mui/material";
import React from "react";
import clockCutted from "../../assests/images/marlboro-new.svg";
import Icons from "../Icons";
import icon from "../../assests/images/step1-icon.svg";
import sampleimage from "../../assests/images/sample-image2.svg";
import VideoModal from "./InstructionVideoModal";
import StepperGreen from "../stepper/Stepper";

import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";

// ✅ Helper translation function to support "path.to.key" syntax
function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
  const t = (key: string, vars?: Record<string, any>) => {
    let text = translate(translations, key) || key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(`{{${k}}}`, v);
      });
    }
    return text;
  };


function Instruction({
  questData,
  sethHasReadInstruction,
}: {
  questData: any;
  sethHasReadInstruction: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const buildImageUrl = (path?: string | null) => {
  if (!path) return null;

  // If DB already gives full URL → use as-is
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Otherwise prefix FE base URL
  return `${process.env.REACT_APP_BASE_URL_image}${path}`;
};
  const tasks =
    questData?.data?.subtasks?.map((subtask: any, index: number) => ({
      subtitle: subtask?.question,
      question_id: subtask?.question_id,
      sampleImage: buildImageUrl(subtask?.sample_picture),
      task_id: subtask?.task_id,
      reward:
        questData?.data.bonus_point > 0
          ? `${t("earn_pnts.points_earn_diwali", {
              points: subtask.points || 0,
              bonus: questData?.data.bonus_point || 0,
            })}`
          : `${t("earn_pnts.points_earn", { points: subtask.points || 0 })}`,
      // reward: `${t('earn_pnts.points_earn', { points: subtask.points || 0 })}`,
      steps:
        subtask?.hint?.steps?.map((step: any) => ({
          step: `${t("taskdetaitls.dot_code_scanning.step_label")}`,
          description: step.step_text,
          // icon: step.step_icon || null,
          icon: buildImageUrl(step?.step_icon),
        })) || [],
      sample_picture: subtask?.hint?.sample_image,
      // takeAPic: subtask?.options[0].option_value
    })) || [];
    const points_earned=questData?.data?.points_earned||0

  return (
    <Box sx={{ paddingBottom: "90px" }}>
      <Box
        sx={{
          borderRadius: "16px",
          border: "1px solid rgba(250, 212, 102, 0.00)",
          background:
            "linear-gradient(110deg, rgba(255, 248, 187, 0.00) 38.52%, rgba(220, 220, 106, 0.32) 100%), #FFF",
          margin: "15px 10px 0 15px",
        }}>
      <Box
        sx={{
          paddingLeft: "16px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ padding: "15px 0" }}>
          <Typography
            variant="caption1"
            sx={{
              color: "#7D7E7F",
              letterSpacing: "0.24px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Task
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", letterSpacing: "0.16px" }}
          >
            {questData?.data?.task}
          </Typography>
        </Box>
        <Box sx={{ padding: "18px 0" }}>
          {questData?.data?.intro_poster && (
            <img
              width={155}
              height={55}
              // crossOrigin="anonymous"
              src={questData?.data?.intro_poster}
              alt="task banner"
            />
          )}
        </Box>
      </Box>
      <Box  sx={{ padding: "5px 15px" }}>
        
         {/* <Typography
            variant="body2"
            sx={{
              color: "#A86403",
              display:"block",
              letterSpacing: "0.24px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
             {t("taskdetaitls.dot_code_scanning.note_label")}
          </Typography> */}
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", letterSpacing: "0.16px",textAlign:"left" }}
          >
            {lang.startsWith("hi")?questData?.data?.task_desc_hi:questData?.data?.task_desc_en}
            {/* {points_earned>0 ?`${t("taskdetaitls.dot_code_scanning.note", { points: points_earned})}`:`${t("taskdetaitls.dot_code_scanning.initnote")}`} */}
          </Typography>
          <Box sx={{padding:'30px 0px 10px 0px'}}>
         {questData?.data?.task_type === t(`taskdetaitls.dot_code_scanning.type`) && <StepperGreen totalSteps={questData?.data?.totalquestions} completedSteps={questData?.data?.questionsAnswered} earndPoints={ questData?.data?.points_earned} showPoints={questData?.data?.can_partially_complete||false} totalPoints={questData?.data?.credit_points} />}
        </Box>
      </Box>
      </Box>
      {tasks
        .filter((va: any, ind: any) => ind === 0)
        .map((task: any, index: any) => (
          <Box
            key={index}
            sx={{
              background: "#FFFFFF",
              borderRadius: "12px",
              margin: "10px 10px",
              textAlign: "left",
            }}
          >
            <Box
              sx={{
                padding: "12px 16px 0px 16px",
                gap: "12px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="caption1"
                sx={{ color: "#7D7E7F", fontWeight: "600", display: "block" }}
              >
                {task.steps[0].step}:
              </Typography>
              {task.steps.map((step: any, stepIndex: any) => (
                <>
                  {(stepIndex > 0 && (
                    <Typography
                      variant="h4"
                      color={"#7D7E7F"}
                      sx={{
                        fontWeight: "600",
                        lineHeight: "1",
                        textAlign: "center",
                      }}
                    >
                      {t("or")}
                    </Typography>
                  )) ||
                    ""}
                  <Box key={stepIndex}>
                    <Box
                      key={stepIndex}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "45px",
                          height: "45px",
                          // backgroundColor: "#FFEBEF",
                          // borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* <Icons name={step.icon} /> */}
                        <img  crossOrigin="anonymous" src={step?.icon || "/default-icon.png"}  alt="Step Icon" />
                      </Box>
                      <Box sx={{ textAlign: "left" }}>
                        <Typography
                          variant="caption1"
                          sx={{ fontWeight: "600", lineHeight: "1" }}
                        >
                          {step.description}
                        </Typography>
                        {stepIndex === 0 && (
                        <VideoModal
                          videoUrl={
                            lang.startsWith("hi_IN")
                              ? questData?.data?.introdution_video?.replace(
                                  "scaning-v1",
                                  "scaning-v1_hindi"
                                )
                              : questData?.data?.introdution_video ||
                                "https://mitrapp2.com/wsa/static/media/dotCode_hin.d66c953b950557e6befe.mp4"
                          }
                        />
                      )}
                      </Box>
                    </Box>
                    {
                        <Box
                          sx={{ position: "relative", padding: "12px 16px" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "16px",
                              background: "#F5F6F7",
                            }}
                          >
                            <img
                              style={{
                                objectFit: "cover",
                                borderRadius: "16px",
                              }}
                              crossOrigin="anonymous"
                              src={
                                // stepIndex === 0 ? sampleimage:task.sampleImage 
                                 stepIndex === 0 ? "/sample_img.png":task.sampleImage
                              }
                              alt="Default"
                              width="100%"
                            />
                          </Box>
                        </Box>
                      }
                  </Box>
                </>
              ))}
              {/* <Typography
                variant="body2"
                component={"a"}
                sx={{
                  fontWeight: "700",
                  letterSpacing: "0.14px",
                  padding: "16px 10px",
                  borderBottom: "1px dashed #C5C6C7",
                  marginTop: "8px",
                }}
                href={'https://dev.mitrapp2.com/wsa/static/media/dotCode_hin.d66c953b950557e6befe.mp4'}
              >
                {t("taskdetaitls.dot_code_scanning.watch_now")}
              </Typography> */}
              {/* <VideoModal videoUrl={i18n.language==="hi"?questData?.data?.introdution_video?.replace("scaning-v1", "scaning-v1_hindi"):questData?.data?.introdution_video||'https://dev.mitrapp2.com/wsa/static/media/dotCode_hin.d66c953b950557e6befe.mp4'}/> */}
              {/* <Box sx={{ position: "relative", padding: "12px 16px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "16px",
                    background: "#F5F6F7",
                  }}
                >
                  <img
                    style={{
                      objectFit: "cover",
                        borderRadius: "16px",
                    }}
                    crossOrigin="anonymous"
                    src={task.sampleImage}
                    alt="Default"
                    width="100%"
                  />
                </Box>
              </Box> */}
            </Box>
          </Box>
        ))}

      <Box className="foot">
        <Button
          type="submit"
          className="btn_red"
          onClick={() => sethHasReadInstruction(true)}
        >
          {t("taskdetaitls.dot_code_scanning.submit")}
        </Button>
      </Box>
    </Box>
  );
}

export default Instruction;
